import IconComponent from 'ui/src/components/icon'
import type Icon from 'ui/src/types/icons'
import { UGELayer } from '../../../../types'

type Props = {
    className?: string
    layer: UGELayer
}

const UGELayersEditorLayerHeaderIcon = ({ className, layer }: Props) => {
    function getIcon(): Icon {
        switch (layer.type) {
            case 'text':
                return 'text'
            default:
                return 'sticker'
        }
    }

    return <IconComponent className={className} height={18} icon={getIcon()} width={18} />
}

export default UGELayersEditorLayerHeaderIcon
